import greatSageBapu from "../assets/images/coursesPage/LordGaveBapu/webp/greatSageBapu.webp";
import greatSageMaiyashree from "../assets/images/coursesPage/LordGaveBapu/webp/maiyashree.webp";

export const greateSageList = [
  {
    image: greatSageBapu,
    title: "Sage Punitachariji Maharaj",
  },
];

export const greateSageMaiyashree = [
  {
    image: greatSageMaiyashree,
    title: "P.P. Maiyashree ShailajaDevi",
  },
];

export const ModalList = [
  {
    name: "Sage Punitachariji Maharaj",
    image: greatSageBapu,
    title: "Sage Punitachariji Maharaj",
    heading: (
      <>
        After <span className="text-light-yellow ms-2">12 Years</span> Of Total
        Sadhana On Mount Girnar
      </>
    ),
    description:
      "One of India's most sacred mountains, the Enlightened Sage known simply as 'Bapu' finally had the darshan of Lord Datta, the eternal Guru of Gurus and Head of the Divine Government. On 15 November 1975, three balls of light coalesced in the classical form of the Lord of Lords, His 3 heads and 6 arms symbolizing God in His Universal and most Benedictory State.",
    subDescription:
      "The Lord wished: to give Bapu a boon. Asking nothing for himself (realizing that to request an end to hunger, poverty & illness would go against human freewill), Bapu requested 'the finest spiritual tool the Lord could devise.' Instantly, all 84 Mahasiddha Immortals appeared in the sky, all singing: 'Hari Om Tatsat Jai Guru Datta.' Bapu, realizing this mantra to be their way of honoring and mediating on the Lord, asked Lord Datta if this was what He - the Unity of Brahma, Vishnu & Shiva wished to bestow. In response, from the Lord's own mouth came, 'Hari Om Tatsat Jai Guru Datta - Go and give this to all who are interested.' Until his passing in 2022, Bapu dedicated his life to serving Sadguru Datta in this way... on behalf of all humanity: 'That they may have something Real,' said Bapu, who founded Girnar Sadhana Ashram and for nearly fifty years taught Sahaj Dhyan Yoga - the Yoga of Spontaneous Meditation.",
  },
];
